module.exports = __webpack_public_path__ + "assets/measure_days_in_inventory.6bf284aa.svg";